declare global {
  interface Window {
    __STORYBOOK_ADDONS_CHANNEL__?: unknown;
  }
}

export const isStorybook = (): boolean => {
  return !!(typeof window !== 'undefined' && window.__STORYBOOK_ADDONS_CHANNEL__);
};
